import React from 'react';

import { Root, type PanelVariant } from './Panel.styles';

export type { PanelVariant };

export type PanelProps = {
  variant?: PanelVariant;
  className?: string;
  children: React.ReactNode;
};

/** Rounded, bordered surface used as the container for each page section. */
export const Panel = ({ variant = 'plain', className, children }: PanelProps): React.ReactElement => (
  <Root $variant={variant} className={className}>
    {children}
  </Root>
);

export default Panel;